<template>
  <div class="lxm-table box is-marginless">
    <!--<div>
      <span class="title is-3">Something</span>
      <span class="is-pulled-right">2016.1.1</span>
    </div>-->
    <table class="table">
      <thead @click="theadClicked" :class="{ 'thead--no-border': !expanded || !rows || rows.length <= 0 }">
        <tr>
          <template v-for="d in heads">
            <th :style="d.style" v-html="html(d)"></th>
          </template>
        </tr>
      </thead>
      <transition name="lxm-transition-fade" mode="out-in">
        <transition-group v-if="expanded"
                          name="lxm-content-transition"
                          tag="tbody"
                          mode="out-in">
          <tr v-for="(row, index) in rows"
              :key="index"
              @click="rowClicked(index)">
            <template v-for="d in row">
              <td :class="{ 'lxm-table__td--success': d && d.success, 'lxm-table__td--fail': d && d.fail }"
                  :style="tdStyle(d)"
                  v-html="html(d)"></td>
            </template>
          </tr>
        </transition-group>
      </transition>
    </table>
  </div>
</template>

<style lang="stylus">
  @import '../../styles/index.styl'
  table-border-width = 1px
  .lxm-table
    width: 100%
    .table
      margin-bottom: 0
      background-color: transparent
      border-collapse: separate
      tr:hover
        background-color: transparent
      th, td
        vertical-align: middle
        border: table-border-width solid white-line
        border-width: 0 0 table-border-width
        color: grey-darker
        background-color: white
      th
        padding: spacing-big 0
      td
        padding: spacing 0
      th:first-child, td:first-child
        padding-left: spacing
      th:last-child, td:last-child
        text-align: right
        padding-right: spacing
      thead
        th, td
          border-width: 0 0 table-border-width
          color: grey-dark
      .thead--no-border
        th, td
          border-width: 0
    &.box
      padding: 0
      background: transparent
      overflow: hidden // 圆角
  .lxm-table__td--success
    color: brand-primary !important
  .lxm-table__td--fail
    color: water-green !important
  .lxm-table__icon
    display: inline-block
    background-repeat: no-repeat
    background-position: center
  .lxm-table__icon--ellipsis
    width: siz(14)
    height: siz(3)
    background-size: siz(14) siz(3)
    background-image: url(../../images/main/table-ellipsis.png)
  .lxm-table__icon--right-arrow
    width: siz(6)
    height: siz(11)
    background-size: siz(6) siz(11)
    background-image: url(../../images/main/table-right-arrow.png)
  .lxm-table__icon--down-arrow
    width: siz(14.5)
    height: siz(14.5)
    background-size: siz(14.5) siz(14.5)
    background-image: url(../../images/main/table-down-arrow.png)
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      heads: Array,
      rows: Array,
      tos: Array,
      expandable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        expanded: true
      }
    },
    methods: {
      tdStyle (d) {
        return d ? d.style : {}
      },
      html (data) {
        if (data) {
          switch (data.type) {
            case 'img':
              return `<img src="${data.value}" />`
            case 'text':
            case 'html':
              return data.value
            case 'icon':
              switch (data.value) {
                case '>':
                  return `<div class="lxm-table__icon lxm-table__icon--right-arrow"></div>`
                case 'v':
                  if (this.expanded) {
                    return `<div class="lxm-table__icon lxm-table__icon--down-arrow" style="transform: rotateX(180deg);"></div>`
                  } else {
                    return `<div class="lxm-table__icon lxm-table__icon--down-arrow"></div>`
                  }
                default:
                  return `<div class="lxm-table__icon lxm-table__icon--ellipsis"></div>`
              }
            default:
              return data
          }
        } else {
          return ''
        }
      },
      rowClicked (index) {
        if (this.tos && this.tos[index]) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(this.tos[index])
        }
      },
      theadClicked () {
        if (this.expandable) {
          this.expanded = !this.expanded
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmTable.vue?247e0097